// extracted by mini-css-extract-plugin
module.exports = {"header":"toolbar_header__2JQ7G","buildVersion":"toolbar_buildVersion__1FEfY"};